import { UserTier } from '../../types';

export const tiers: UserTier[] = [
  {
    value: 'essentials',
    displayValue: 'Essentials',
    rank: -3,
  },
  {
    value: 'beyond',
    displayValue: 'Starter',
    rank: -1,
  },
  {
    value: 'starter',
    displayValue: 'Starter',
    rank: 0,
  },
  {
    value: 'trial',
    displayValue: 'Trial',
    rank: 1,
  },
  {
    value: 'core',
    displayValue: 'Standard',
    rank: 1,
  },
  {
    value: 'standard',
    displayValue: 'Standard',
    rank: 1,
  },
  {
    value: 'enterprise',
    displayValue: 'Enterprise',
    rank: 2,
  },
];

export const gPanelTiers = {
  essentials: tiers.find((tier) => tier.value === 'essentials')!,
  beyond: tiers.find((tier) => tier.value === 'beyond')!,
  starter: tiers.find((tier) => tier.value === 'starter')!,
  core: tiers.find((tier) => tier.value === 'core')!,
  trial: tiers.find((tier) => tier.value === 'trial')!,
  standard: tiers.find((tier) => tier.value === 'standard')!,
  enterprise: tiers.find((tier) => tier.value === 'enterprise')!,
};
